
import { httpClient } from "@/lib/http-client/http-client";
import { API_ROUTES } from "@/shared/constants/api.routes";
import { IRegionGetResponse } from "../interface/responses/IReginResponse";

class RegionService {
  constructor() {}

  public async getRegions() {
    const response = await httpClient.get<IRegionGetResponse>(API_ROUTES.Region.root);
    return response;
  }

  public async updateRegion(companyId: string, specificationId: string, regionId: string) {
    const response = await httpClient.patch<IRegionGetResponse>(API_ROUTES.Region.update(companyId, specificationId), {
      regionId: regionId,
    });
    return response;
  }
}

export const regionService = new RegionService();
